module.exports = __webpack_public_path__ + "img/thumbnail_Capybara_j_normal.97f29de5.png";